import { render, staticRenderFns } from "./FulfillmentOmsDetail.vue?vue&type=template&id=629da80c&scoped=true&"
import script from "./FulfillmentOmsDetail.vue?vue&type=script&lang=js&"
export * from "./FulfillmentOmsDetail.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentOmsDetail.vue?vue&type=style&index=0&id=629da80c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629da80c",
  null
  
)

export default component.exports